module.exports = __webpack_public_path__ + "img/ROBERT.b939ed9c.png";